import { Box, BoxProps } from '@mantine/core';
import { ExtFormType } from '../../../api/extForms';
import { LogoExtendedIcon } from '../../../icons';

export type LogoProps = BoxProps & {
  organisation: ExtFormType['organisation'];
};
export const Logo: React.FC<LogoProps> = ({ organisation, ...boxProps }) => (
  <Box {...boxProps}>
    {organisation?.logoUrl ? (
      <img
        src={organisation?.logoUrl}
        alt={organisation?.name}
        width={120}
        height={40}
        style={{ objectFit: 'contain' }}
      />
    ) : (
      <LogoExtendedIcon color="black" width={192} height={96} />
    )}
  </Box>
);
